import styled from 'styled-components';

export const StyledStatusPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 84px;
  max-width: 700px;
  margin: 0 auto;

  i {
    font-size: 70px;
    color: ${({ iconColor }) => iconColor};
    position: relative;
    z-index: 1;

    &:after {
      content: '';
      position: absolute;
      width: 70px;
      height: 70px;
      background: ${({ accentColor }) => accentColor};
      top: 0;
      left: 0;
      transform: translate(-25%, -25%);
      border-radius: 50%;
      z-index: -1;
    }
  }
`;

export const Content = styled.div`
  color: #333;
  margin-top: 24px;
  font-size: 18px;
  text-align: center;
`;
